var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-space',[_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.confirmToEffective}},[_vm._v("生效")]),_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.confirmToIneffective}},[_vm._v("失效")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }